import { Database, push, ref } from 'firebase/database';

export type LeadData = {
  name?: string;
  phone: string;
  email: string;
  notes: string;
  createdAt?: number;
};

export const leadStore = async (database: Database, data: LeadData): Promise<void> => {
  const normalizedLead: LeadData = {
    name: data.name?.trim() || undefined,
    phone: data.phone.trim(),
    email: data.email.trim(),
    notes: data.notes.trim(),
    createdAt: data.createdAt ?? Date.now(),
  };

  await push(ref(database, 'leads'), normalizedLead);
};
